import { MenuItem, Message, Steps } from "primeng/primeng";
import { MenuItemEx } from "./menu-item-ex";
import { LoginService } from "../services/login.service";
import { IppaymentService } from "../services/ippayment.service";
import { OnInit, ViewChild } from "@angular/core";
import { ApplicantDetailsComponent } from "../components/applicant-details/applicant-details.component";
import { User } from "./user";
import { IppaymentComponent } from "../components/ippayment/ippayment.component";
import { ApplicationBase } from "./application-base";
import { Router } from "@angular/router";
import { UploadFileInformation } from "./upload-file-information";

import { ApplicationServiceBase } from "../services/application-service-base";
import { AddressDetailsComponent } from "../components/address-details/address-details.component";
import { AddressViewmodel } from "../viewmodels/address-viewmodel";
import { UploadFileComponent } from "../components/upload-file/upload-file.component";
import { TermsConditionsData } from "./terms-conditions-data";
import { PaymentData } from "./payment-data";
import { SubmitButtonComponent } from "../components/submit-button/submit-button.component";
import { LocationDetails } from "./location-details";
import { UploadFile2Component } from "../../shared/components/upload-file2/upload-file2.component";
import { UploadFile2Information } from "./upload-file2-information";
import { UploadFile3Component } from "../../shared/components/upload-file3/upload-file3.component";
import { UploadFile3Information } from "./upload-file3-information";
import { ServiceBase } from "../../shared/services/service-base";
import { environment } from "../../../app-environments/environment";

export abstract class ApplicationFormBase<T extends ApplicationBase>
  implements OnInit {
  @ViewChild("AddressDetailsComponent") location: AddressDetailsComponent;
  @ViewChild("ApplicantDetailsComponent") applicant: ApplicantDetailsComponent;
  @ViewChild(IppaymentComponent) ippaymentComponent: IppaymentComponent;
  @ViewChild(SubmitButtonComponent)
  submitButtonComponent: SubmitButtonComponent;
  @ViewChild("UploadFileComponent") uploadFileComponent: UploadFileComponent;
  @ViewChild("UploadFloorPlanFileComponent") uploadFloorPlanFileComponent: UploadFileComponent;
  applicantDetails: User;
  items: MenuItem[] = [];
  msgs: Message[] = [];
  isRequesting: boolean;

  constructor(
    protected applicationService?: ApplicationServiceBase<T>,
    protected loginService?: LoginService,
    protected ipPaymentService?: IppaymentService,
    protected router?: Router
  ) { }

  protected addMenuItem(
    label: string,
    me: any,
    activeIndex: number,
    summary: string
  ): void {
    me.items.push(<MenuItemEx>{
      me: me,
      label: label,
      command: (event: any) => {
        me.activeIndex = activeIndex;
        this.msgs.length = 0;
        this.msgs.push({
          severity: "info",
          summary: summary,
          detail: event.item.label,
        });
      },
    });
  }

  protected removeMenuItem(label: string, me: any): void {
    me.items = me.items.filter((x: MenuItemEx) => x.label != label);
  }

  ngOnInit() { }

  get methodOfApproval(): string {
    return this.applicationService.applicationData.methodOfApproval;
  }

  set methodOfApproval(v: string) {
    this.applicationService.applicationData.methodOfApproval = v;
  }

  initPfiAndBoe(totalOrderAmount: number): void {
    const me = this;

    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(5, this.getTotalOrderAmount());
    });

    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(
        this.applicationService.applicationData.applicant
      );
      this.addMenuItem("Location details", me, 0, "First Step");
      this.addMenuItem("Work request", me, 1, "Second Step");
      this.addMenuItem("Upload files", me, 2, "Third Step");
      this.addMenuItem("Applicant details", me, 3, "Fourth Step");
      this.addMenuItem("Review and submit", me, 4, "Fifth Step");
    } else {
      // this.setApplicantDetailsForGuestUser(
      //   this.applicationService.applicationData.applicant
      // );
      this.setApplicantDetailsForNonBillLater(
        this.applicationService.applicationData.applicant
      );
      this.addMenuItem("Location details", me, 0, "First Step");
      this.addMenuItem("Work request", me, 1, "Second Step");
      this.addMenuItem("Upload files", me, 2, "Third Step");
      this.addMenuItem("Applicant details", me, 3, "Fourth Step");
      this.addMenuItem("Review and submit", me, 4, "Fifth Step");
      this.addMenuItem("Payment", me, 5, "Sixth Step");
    }
    this.loadFees();
  }

  get submitErrorMessage(): string {
    return this.applicationService.submitErrorMessage;
  }

  set submitErrorMessage(v: string) {
    this.applicationService.submitErrorMessage = v;
  }

  get termsConditionsData(): TermsConditionsData {
    return this.applicationService.termsConditionsData;
  }

  get agreedToTsAndCs(): boolean {
    return this.applicationService.termsConditionsData.agreedToTsAndCs;
  }

  set agreedToTsAndCs(v: boolean) {
    this.applicationService.termsConditionsData.agreedToTsAndCs = v;
  }

  get authorisationTsAndCs(): boolean {
    return this.applicationService.termsConditionsData.authorisationTsAndCs;
  }

  set authorisationTsAndCs(v: boolean) {
    this.applicationService.termsConditionsData.authorisationTsAndCs = v;
  }

  set selectedTitleId(v: string) {
    if (this.applicant) {
      this.applicant.selectedTitleId = v;
    }
  }

  abstract getTotalOrderAmount(): number;

  protected navigateFromLocation(executeYes: any, executeNo: any): void {
    if (this.location.invalid) {
      this.location.displayErrorMessage();
      executeNo();
    } else {
      this.location.displayErrorMessage();
      executeYes();
    }
  }

  protected navigateFromLocationWithPlan(
    executeYes: any,
    executeNo: any
  ): void {
    if (this.location.invalidPlan) {
      this.location.displayPlanErrorMessage();
      executeNo();
    } else {
      this.location.displayPlanErrorMessage();
      executeYes();
    }
  }

  protected navigateFromLocationForPFI(
    executeYes: any,
    executeNo: any
  ): void {
    if (this.location.invalidStreetName || this.location.invalidStreetNo || this.location.invalidSuburb) {
      this.location.displayAddressMandatoryErrorMessage();
      executeNo();
    } else {
      this.location.displayAddressMandatoryErrorMessage();
      executeYes();
    }
  }

  protected setApplicantData(): void {
    this.applicationService.submitErrorMessage = null;
    this.isRequesting = true;
    if (this.applicant) this.applicationService.applicationData.applicant = this.applicant.applicantDetails;
    if (
      this.loginService.isTechCSOUserLoggedIn() ||
      this.loginService.isSystemAdminUserLoggedIn()
    ) {
      if (this.applicant) this.applicationService.applicationData.consumerNo = this.applicant.applicantDetails.accountNumber;
    } else {
      this.applicationService.applicationData.consumerNo = this.loginService.getUser().accountNumber;
    }
    if (
      this.location &&
      this.location.addressDetails &&
      this.location.addressDetails.installationNumber
    ) {
      this.applicationService.applicationData.installationNumber = this.location.addressDetails.installationNumber;
    }
    //this.applicationService.applicationData.isGuestUser = this.applicant.isGuestUserLoggedIn();

    if (
      this.uploadFileComponent &&
      this.uploadFileComponent.uploadfilesViewmodel.isDropbox
    ) {
      this.applicationService.workRequestViewModel.workrequestDetails.comment =
        "File Location Url: " +
        this.uploadFileComponent.uploadfilesViewmodel.dropboxUrl;
    }
  }

  protected redirectForBillLater(
    damsApplicationId: string,
    appType: string,
    totalOrderAmount: number,
    options?: any
  ): void {
    this.isRequesting = false;
    this.applicationService.initializeData();

    let routerParams: any = ['/applicationConfirm'];
    if (options && options.data) {
      routerParams.push(options.data);
    }

    this.router.navigate(routerParams, {
      queryParams: {
        DAMSApplicationId: damsApplicationId,
        AppType: appType,
        TotalOrderAmount: totalOrderAmount,
      },
    });
    this.enableDisableSubmitBtn(false);
  }

  protected redirectForLndBillLater(
    damsApplicationId: string,
    appType: string,
    totalOrderAmount: number
  ): void {
    this.isRequesting = false;
    this.applicationService.initializeData();
    this.router.navigate(["/lndApplicationConfirm"], {
      queryParams: {
        DAMSApplicationId: damsApplicationId,
        AppType: appType,
        TotalOrderAmount: totalOrderAmount,
      },
    });
    this.enableDisableSubmitBtn(false);
  }

  protected setErrorForUpdateFileUploadInformation(
    callback: any,
    err: any
  ): void {
    this.enableDisableSubmitBtn(false);
    // if (this.isGuestUserLoggedIn) {
    //   if (callback) {
    //     callback({ status: false, damsApplicationId: null });
    //   }
    // }
    this.isRequesting = false;
    if (err.status === 400) {
      this.applicationService.submitErrorMessage = err.message;
    } else {
      this.applicationService.submitErrorMessage = "Error uploading the files";
      this.applicationService.serverError.next("Error uploading the files");
    }
  }

  protected setErrorForUploadFile(callback: any): void {
    // if (this.isGuestUserLoggedIn) {
    //   if (callback) {
    //     callback({ status: false, damsApplicationId: null });
    //   }
    // }
    this.isRequesting = false;
    // Log errors if any
    this.applicationService.submitErrorMessage = "Error uploading the files";
    this.enableDisableSubmitBtn(false);
    this.applicationService.serverError.next("Error uploading the files");
  }

  protected setDataWhenDamsIDIsNull(callback: any): void {
    this.enableDisableSubmitBtn(false);
    // if (this.isGuestUserLoggedIn) {
    //   if (callback) {
    //     callback({ status: false, damsApplicationId: null });
    //   }
    // }
    this.isRequesting = false;
    this.applicationService.submitErrorMessage =
      "Error submitting the application";

    this.applicationService.serverError.next(
      "Error submitting the application"
    );
  }

  protected setErrorSubmittingApplication(callback: any, err: any): void {
    this.enableDisableSubmitBtn(false);
    // if (this.isGuestUserLoggedIn) {
    //   if (callback) {
    //     callback({ status: false, damsApplicationId: null });
    //   }
    // }

    this.isRequesting = false;
    // Log errors if any
    if (err.status === 404) {
      this.applicationService.submitErrorMessage = err.error.err;
      this.applicationService.serverError.next(err.error.err);
    } else {
      this.applicationService.submitErrorMessage =
        "Error submitting the application";
      this.applicationService.serverError.next(
        "Error submitting the application"
      );
    }
    console.log(err);
  }

  get commitDisabled(): boolean {
    return false;
  }

  //protected redirectGuestUser(
  protected redirectForNonBillLater(
    callback: any,
    damsApplicationId: string,
    totalOrderAmount: number,
    options?: any
  ): void {
    if (totalOrderAmount > 0) {
      this.isRequesting = false;

      if (callback) {
        callback({ status: true, damsApplicationId: damsApplicationId });
        this.enableDisableSubmitBtn(false);
      } else {
        this.checkoutIpPaymentSession(
          this.ippaymentComponent,
          damsApplicationId,
          this.getPaymentAmount(totalOrderAmount),
          (sessionId, sst, error) => {
            this.enableDisableSubmitBtn(false);
            if (error) {
              this.applicationService.submitErrorMessage = error.error.err.msg;
              return;
            }
            this.applicationService.paymentData.sessionId = sessionId;
            this.applicationService.paymentData.sst = sst;
            this.applicationService.applicationData.damsApplicationID = damsApplicationId;
            this.activeIndex++;
          }
        );
      }
    } else {
      this.redirectForBillLater(damsApplicationId, options.appType, totalOrderAmount);
    }
  }

  paymentformIsInit(tabIndex: number, totalOrderAmount: number): void {
    if (
      this.activeIndex === tabIndex &&
      this.applicationService.applicationData.damsApplicationID !== ""
    ) {
      this.checkoutIpPaymentSession(
        this.ippaymentComponent,
        this.applicationService.applicationData.damsApplicationID,
        this.getPaymentAmount(totalOrderAmount),
        (sessionId, sst) => {
          this.applicationService.paymentData.sessionId = sessionId;
          this.applicationService.paymentData.sst = sst;
        }
      );
    }
  }

  get isRecycledWaterZone(): boolean {
    return this.location.IsRecycledWaterZone;
  }

  //navigateToPaymentWhenGuestUser(
  navigateToPaymentWhenNonBillLaterUser(
    executeYes,
    executeNo,
    totalOrderAmount: number,
    submitApplication: any
  ): void {
    submitApplication((result: any) => {
      if (result.status) {
        this.checkoutIpPaymentSession(
          this.ippaymentComponent,
          result.damsApplicationId,
          this.getPaymentAmount(totalOrderAmount),
          (sessionId, sst, error) => {
            if (error) {
              this.applicationService.submitErrorMessage = error.msg;
              executeNo();
              return;
            }
            this.applicationService.paymentData.sessionId = sessionId;
            this.applicationService.paymentData.sst = sst;
            this.applicationService.applicationData.damsApplicationID =
              result.damsApplicationId;
            executeYes();
          }
        );
      }
    });
    executeNo();
  }

  onViewModelChange($event) {
    this.applicationService.addressViewModel = $event;
  }

  get applicantDetailsViewModel(): User {
    return this.applicationService.applicationData.applicant;
  }

  get addressViewModel(): AddressViewmodel {
    return this.applicationService.addressViewModel;
  }

  get locationDetails(): LocationDetails {
    return this.applicationService.addressViewModel.addressDetails;
  }

  get streetType(): string {
    if (!this.location.streetTypes) {
      return "";
    }

    return this.location.streetTypes.selectedItem
      ? this.location.streetTypes.selectedItem.display
      : "";
  }

  get streetSuffixType(): string {
    if (!this.location.streetSuffixTypes) {
      return "";
    }

    return this.location.streetSuffixTypes.selectedItem
      ? this.location.streetSuffixTypes.selectedItem.display
      : "";
  }

  set activeIndex(v: number) {
    this.applicationService.activeIndex = v;
  }

  get activeIndex(): number {
    return this.applicationService.activeIndex;
  }

  get isGuestUserLoggedIn(): boolean {
    return this.loginService.isGuestUserLoggedIn();
  }

  get isLandlineMandatory(): boolean {
    return !this.isGuestUserLoggedIn;
  }

  get isMobileMandatory(): boolean {
    return this.isGuestUserLoggedIn;
  }

  get isUserBillLater(): boolean {
    return this.loginService.isUserBillLater();
  }

  get paymentData(): PaymentData {
    return this.applicationService.paymentData;
  }

  protected newApplication(): void {
    this.applicationService.initializeData();
    if (this.ippaymentComponent) {
      this.ippaymentComponent.setDefaultHeight();
    }

    if (this.location && this.location.streetTypes) {
      this.location.streetTypes.selectedItemId = 0;
      this.location.setFocusOnFirstElement();
    }

    if (this.location && this.location.streetSuffixTypes) {
      this.location.streetSuffixTypes.selectedItemId = 0;
    }

    if (this.applicant) {
      this.applicant.markValidationControlsAsUntouched();
      this.applicant.clearTitle();
    }
    this.loadFees();
  }

  protected setApplicantDetailsForBillLater(applicantDetails: User) {
    this.applicantDetails = applicantDetails;
    this.applicantDetails.billLater = true;
    this.setApplicantDetails(
      this.loginService.getUser().title,
      this.loginService.getUser().firstName,
      this.loginService.getUser().lastName,
      this.loginService.getUser().landLine,
      this.loginService.getUser().email,
      this.loginService.getUser().mobile,
      this.loginService.getUser().postalAddress
    );
  }

  //todo
  protected setApplicantDetailsForNonBillLater(applicantDetails: User) {
    this.applicantDetails = applicantDetails;
    this.applicantDetails.billLater = false;
    this.setApplicantDetails(
      this.loginService.getUser().title,
      this.loginService.getUser().firstName,
      this.loginService.getUser().lastName,
      this.loginService.getUser().landLine,
      this.loginService.getUser().email,
      this.loginService.getUser().mobile,
      this.loginService.getUser().postalAddress
    );
  }

  // protected setApplicantDetailsForGuestUser(applicantDetails: User) {
  //   this.applicantDetails = applicantDetails;
  // }

  private setApplicantDetails(
    title: string,
    firstName: string,
    lastName: string,
    landline: string,
    email: string,
    mobile: string,
    postAddress: string
  ) {
    this.applicantDetails.title = title;
    this.applicantDetails.firstName = firstName;
    this.applicantDetails.lastName = lastName;
    this.applicantDetails.landLine = landline;
    this.applicantDetails.email = email;
    this.applicantDetails.mobile = mobile;
    this.applicantDetails.postalAddress = postAddress;
    this.applicantDetails.accountName = this.loginService.getUser().accountName;
    this.applicantDetails.accountNumber = this.loginService.getUser().accountNumber;
  }

  protected checkoutIpPaymentSession(
    ippaymentComponent: IppaymentComponent,
    damsApplicationId: string,
    paymentAmount: string,
    callback: (sessionId: string, sst: string, error: any) => void
  ): void {
    ippaymentComponent.checkOutPaymentSession(
      this.loginService.getAccountNumber(),
      damsApplicationId,
      paymentAmount,
      callback
    );
  }

  protected getPaymentAmount(totalOrderAmount: number): string {
    return (totalOrderAmount * 100).toString();
  }

  get sessionId(): string {
    return this.applicationService.paymentData.sessionId;
  }

  get sst(): string {
    return this.applicationService.paymentData.sst;
  }

  get sessionAlreadyExists(): boolean {
    return (
      this.applicationService.paymentData.sessionId &&
      this.applicationService.paymentData.sessionId.length > 0 &&
      this.applicationService.paymentData.sst &&
      this.applicationService.paymentData.sst.length > 0
    );
  }

  enableDisableSubmitBtn(v: boolean) {
    if (this.submitButtonComponent) {
      this.submitButtonComponent.enableDisableSubmitBtn = v;
    }
  }

  executeSubmit(
    appType: string,
    callback: any,
    totalOrderAmount: number,
    uploadFileComponent: UploadFileComponent,
    redirectToPayment: boolean,
    uploadFileComponent2?: UploadFile2Component,
    uploadFileComponent3?: UploadFile3Component,
    floorPlanUploadFileComponent?: UploadFileComponent
  ): void {

    const reqPayload: any = {
      appType,
      totalOrderAmount,
      redirectToPayment,
      callback,
      isUserLoggedIn: this.loginService.isUserLoggedIn(),
      isUserBillLater: this.loginService.isUserBillLater(),
      applicationDetails: this.applicationService.applicationData,
      fileUploadComps: {
        uploadFileComponent, uploadFileComponent2, uploadFileComponent3, floorPlanUploadFileComponent
      }
    };

    // log if not production
    if (!environment.production) {
      console.log("called executeSubmit() with params: ", reqPayload);
    }

    const me: any = this;
    this.enableDisableSubmitBtn(true);

    // set refNum as 'NA' if refNum in (null, undefined, '')
    if (this.applicationService && this.applicationService.applicationData &&
      [null, undefined, ''].indexOf(this.applicationService.applicationData.refNum) > -1)
    {
      this.applicationService.applicationData['refNum'] = 'NA';
    }

    // set title as NULL if no title exists
    if (this.applicationService && this.applicationService.applicationData &&
      this.applicationService.applicationData.applicant && this.applicationService.applicationData.applicant.title &&
      this.applicationService.applicationData.applicant.title === 'Please Select...')
    {
      this.applicationService.applicationData.applicant.title = null;
    }

    this.applicationService
      .submit(this.applicationService.applicationData, this.loginService.getToken())
      .subscribe(async (DAMSApplicationId) => {
        this.isRequesting = false;
        if (DAMSApplicationId && DAMSApplicationId.length > 0) {


          const funcUploadFileComponent = async () => {
            // calls node api to import files
            const uploadFileInfo = (uploadFilesResult: string[]) => {
              const uploadFileInfo: UploadFileInformation = new UploadFileInformation();

              let address: string = null;
              if (me.location && me.location.addressDetails && me.location.addressDetails.locationAddress) {
                address = me.location.addressDetails.locationAddress;
              }

              // set data for upload file info
              uploadFileInfo.setData(appType.toUpperCase(), DAMSApplicationId, address, uploadFilesResult);

              uploadFileComponent
                .updateFileInformation(uploadFileInfo)
                .subscribe(
                  (res) => {
                    if (appType === 'lnd-w' || appType === 'lnd-nw') {
                      this.redirectForLndBillLater(DAMSApplicationId, appType, totalOrderAmount);
                    } else if (this.loginService.isUserLoggedIn()) {
                      if (!this.loginService.isUserBillLater()) {
                        this.redirectForNonBillLater(callback, DAMSApplicationId, totalOrderAmount, { appType });
                      } else {
                        this.redirectForBillLater(DAMSApplicationId, appType, totalOrderAmount);
                      }
                    }
                  },
                  (err) => {
                    this.setErrorForUpdateFileUploadInformation(callback, err);
                  }
                );
            };

            try {

              // calls DAMS API to upload flies
              const uploadFilesResult: string[] = await uploadFileComponent.uploadFiles().toPromise();

              if (floorPlanUploadFileComponent && !floorPlanUploadFileComponent.uploadfilesViewmodel.isDropbox) {

                // calls DAMS API to upload files
                const uploadFloorPlanFilesResult: string[] = await floorPlanUploadFileComponent.uploadFiles(true).toPromise();
                uploadFileInfo([...uploadFilesResult, ...uploadFloorPlanFilesResult]);

              } else {
                uploadFileInfo(uploadFilesResult);
              }

            } catch (ex) {
              this.setErrorForUploadFile(callback);
            }
          };
          const funcUploadFileComponent2 = async () => {
            if (uploadFileComponent2.fileListComponent) {
              if (uploadFileComponent2.fileListComponent.length > 0) {
                uploadFileComponent2.uploadFiles().subscribe(
                  (result: any) => {
                    const upload2FileInfo: UploadFile2Information = new UploadFile2Information();
                    let address: string = null;
                    if (
                      me.location &&
                      me.location.addressDetails &&
                      me.location.addressDetails.locationAddress
                    ) {
                      address = me.location.addressDetails.locationAddress;
                    }

                    if (result) {
                      let uploadFileResult = [];
                      result.map((x, i) => {
                        uploadFileComponent2.fileListComponent.map((y) => {
                          let temp = ServiceBase.sanitizeString(y.file.name);
                          if (x.includes(temp)) {
                            uploadFileResult.push({
                              name: x,
                              attachmentType: y.attachmentType,
                            });
                          }
                        });
                      });

                      result = uploadFileResult;
                    }

                    upload2FileInfo.setData(
                      appType.toUpperCase(),
                      DAMSApplicationId,
                      address,
                      result
                    );
                    uploadFileComponent2
                      .updateFileInformation(upload2FileInfo)
                      .subscribe(
                        (res) => {
                          if (appType === 'lnd-w' || appType === 'lnd-nw') {
                            this.redirectForLndBillLater(
                              DAMSApplicationId,
                              appType,
                              totalOrderAmount
                            );
                            // } else if (this.loginService.isUserBillLater()) {
                            //   this.redirectForBillLater(
                            //     DAMSApplicationId,
                            //     appType,
                            //     totalOrderAmount
                            //   );
                            //} else if (this.isGuestUserLoggedIn) {
                          } else if (this.loginService.isUserLoggedIn()) {
                            // if (redirectToPayment) {
                            if (!this.loginService.isUserBillLater()) {
                              //this.redirectGuestUser(
                              this.redirectForNonBillLater(
                                callback,
                                DAMSApplicationId,
                                totalOrderAmount,
                                { appType }
                              );
                            } else {
                              this.redirectForBillLater(
                                DAMSApplicationId,
                                appType,
                                totalOrderAmount
                              );
                            }
                          }
                        },
                        (err) => {
                          this.setErrorForUpdateFileUploadInformation(
                            callback,
                            err
                          );
                        }
                      );
                  },
                  (err) => {
                    this.setErrorForUploadFile(callback);
                  }
                );
              } else {
                if (appType === 'lnd-w' || appType === 'lnd-nw') {
                  this.redirectForLndBillLater(
                    DAMSApplicationId,
                    appType,
                    totalOrderAmount
                  );
                  // } else if (!this.isGuestUserLoggedIn) {
                  //   this.redirectForBillLater(
                  //     DAMSApplicationId,
                  //     appType,
                  //     totalOrderAmount
                  //   );
                  //} else if (this.isGuestUserLoggedIn) {
                } else if (this.loginService.isUserLoggedIn()) {
                  // if (redirectToPayment) {
                  if (!this.loginService.isUserBillLater()) {
                    //this.redirectGuestUser(
                    this.redirectForNonBillLater(
                      callback,
                      DAMSApplicationId,
                      totalOrderAmount,
                      { appType }
                    );
                  } else {
                    this.redirectForBillLater(
                      DAMSApplicationId,
                      appType,
                      totalOrderAmount
                    );
                  }
                }
              }
            }
          };
          const funcUploadFileComponent3 = async () => {
            if (uploadFileComponent3.fileListComponent &&
              !uploadFileComponent3.uploadfilesViewmodel.isDropbox
            ) {
              uploadFileComponent3.uploadFiles().subscribe(
                (result: any) => {
                  const upload3FileInfo: UploadFile3Information = new UploadFile3Information();
                  let address: string = null;
                  if (
                    me.location &&
                    me.location.addressDetails &&
                    me.location.addressDetails.locationAddress
                  ) {
                    address = me.location.addressDetails.locationAddress;
                  }
                  if (result) {
                    let uploadFileResult = [];
                    result.map((x, i) => {
                      uploadFileComponent3.fileListComponent.map((y) => {
                        let temp = ServiceBase.sanitizeString(y.file.name);
                        if (x.includes(temp)) {
                          uploadFileResult.push({
                            name: x,
                            attachmentType: y.attachmentType,
                          });
                        }
                      });
                    });

                    result = uploadFileResult;
                  }

                  upload3FileInfo.setData(
                    appType.toUpperCase(),
                    DAMSApplicationId,
                    address,
                    result
                  );
                  uploadFileComponent3
                    .updateFileInformation(upload3FileInfo)
                    .subscribe(
                      (res) => {
                        if (appType === 'lnd-w' || appType === 'lnd-nw') {
                          this.redirectForLndBillLater(
                            DAMSApplicationId,
                            appType,
                            totalOrderAmount
                          );
                          // } else if (!this.isGuestUserLoggedIn) {
                          //   this.redirectForBillLater(
                          //     DAMSApplicationId,
                          //     appType,
                          //     totalOrderAmount
                          //   );
                          //} else if (this.isGuestUserLoggedIn) {
                        } else if (this.loginService.isUserLoggedIn()) {
                          // if (redirectToPayment) {
                          if (!this.loginService.isUserBillLater()) {
                            // this.redirectGuestUser(
                            this.redirectForNonBillLater(
                              callback,
                              DAMSApplicationId,
                              totalOrderAmount,
                              { appType }
                            );
                          } else {
                            this.redirectForBillLater(
                              DAMSApplicationId,
                              appType,
                              totalOrderAmount
                            );
                          }
                        }
                      },
                      (err) => {
                        this.setErrorForUpdateFileUploadInformation(
                          callback,
                          err
                        );
                      }
                    );
                },
                (err) => {
                  this.setErrorForUploadFile(callback);
                }
              );

            }
          };
          const funcDefault = async () => {
            if (appType === 'lnd-w' || appType === 'lnd-nw') {
              this.redirectForLndBillLater(
                DAMSApplicationId,
                appType,
                totalOrderAmount
              );
            } else if (appType === 'rwi') {
              // if (!this.loginService.isUserBillLater()) {
              //   this.redirectForNonBillLater(
              //     callback,
              //     DAMSApplicationId,
              //     totalOrderAmount,
              //     { data: { calendlyRedirect: this.validateForCalendlyRedirect() } }
              //   );
              // } else {
              this.redirectForBillLater(
                DAMSApplicationId,
                appType,
                totalOrderAmount,
                { data: { calendlyRedirect: this.validateForCalendlyRedirect() } }
              );
              // }
            } else if (appType === 'mfb') {
              this.redirectForBillLater(
                DAMSApplicationId,
                appType,
                totalOrderAmount
              );
              // }
            } else if (this.loginService.isUserLoggedIn()) {

              if (!this.loginService.isUserBillLater()) {
                this.redirectForNonBillLater(
                  callback,
                  DAMSApplicationId,
                  totalOrderAmount,
                  { appType }
                );
              } else {
                this.redirectForBillLater(
                  DAMSApplicationId,
                  appType,
                  totalOrderAmount
                );
              }
            }
          };

          if (uploadFileComponent && !uploadFileComponent.uploadfilesViewmodel.isDropbox) {
            funcUploadFileComponent();
          } else if (uploadFileComponent2) {
            funcUploadFileComponent2();
          } else if (uploadFileComponent3) {
            funcUploadFileComponent3();
          }
          else {
            funcDefault();
          }
        } else {
          this.setDataWhenDamsIDIsNull(callback);
        }
      },
        (err) => {
          console.log("err while fetching DAMSApplicationId");
          console.log(err);
          this.setErrorSubmittingApplication(callback, err);
        }
      );
  }

  protected loadFees() { }

  validTermsAndConditions(executeNo: any, executeYes: any): boolean {
    if (!this.applicationService.termsConditionsData.agreedToTsAndCs) {
      this.applicationService.submitErrorMessage +=
        "Please select terms and conditions.";
      executeNo();
      return;
    }

    if (!this.applicationService.termsConditionsData.authorisationTsAndCs) {
      this.applicationService.submitErrorMessage +=
        "Please select authorisation terms and conditions.";
      executeNo();
      return;
    }

    // for western props only
    if ([true, false].indexOf(this.applicationService.termsConditionsData.breachOfInfoTsAndCs) > -1 &&
      [true, false].indexOf(this.applicationService.termsConditionsData.discretionTsAndCs) > -1) {
      if (!this.applicationService.termsConditionsData.breachOfInfoTsAndCs) {
        this.applicationService.submitErrorMessage += `Please select terms and conditions.`;
        executeNo();
        return;
      }

      if (!this.applicationService.termsConditionsData.discretionTsAndCs) {
        this.applicationService.submitErrorMessage += `Please select terms and conditions.`;
        executeNo();
        return;
      }
    }

    executeYes();
  }

  validateForCalendlyRedirect() {
    let redirect = false;
    const wrd = this.applicationService.applicationData['workrequestDetails'];

    if (wrd && ['r2ap', 'r1r2ap', 'r3', 'r3cfo', 'r1r3cfo'].indexOf((wrd['typeOfInspection'] || '').toLowerCase()) > -1) {
      redirect = true;
    }

    return redirect;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/application-form-base.ts